// import { useState } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import { login } from "../auth";

// const Login = () => {
//   const [form, setForm] = useState({ username: "", password: "" });
//   const [error, setError] = useState("");
//   const [loading, setLoading] = useState(false);
//   const navigate = useNavigate();
//   const location = useLocation();

//   const from = location.state?.from?.pathname || "/dashboard";

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setForm((f) => ({ ...f, [name]: value }));
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     setError("");
//     setLoading(true);

//     const ok = login(form.username.trim(), form.password);
//     setLoading(false);

//     if (!ok) {
//       setError("Invalid username or password.");
//       return;
//     }
//     navigate(from, { replace: true });
//   };

//   return (
//     <div className="login-fullpage">
//       <div className="login-card">
//         <div className="login-card-header">
//           {/* Logo circle – replace QS with your logo if needed */}
//           {/* <div className="login-logo-circle">QS</div> */}
//           <div className="login-logo-big">
//             <img src="/logo.png" alt="Quantumnique logo" className="login-logo-img" />
//             </div>
//           <div>
//             <h1 className="login-title">Payslip Admin</h1>
//             <p className="login-subtitle">
//               Sign in with your admin credentials to manage payroll.
//             </p>
//           </div>
//         </div>

//         <form onSubmit={handleSubmit}>
//           <div className="fieldLogin">
//             <label className="field-label-login">Username</label>
//             <input
//               className="field-input-login"
//               name="username"
//               value={form.username}
//               onChange={handleChange}
//               placeholder="admin"
//               autoComplete="off"
//             />
//           </div>

//           <div className="fieldLogin" style={{ marginTop: 12 }}>
//             <label className="field-label-login">Password</label>
//             <input
//               className="field-input-login"
//               type="password"
//               name="password"
//               value={form.password}
//               onChange={handleChange}
//               placeholder="••••••••"
//             />
//           </div>

//           {error && <div className="login-error">{error}</div>}

//           <button
//             type="submit"
//             className="btn-primary-large login-submit-btn"
//             disabled={loading}
//           >
//             {loading ? "Signing in…" : "Sign In"}
//           </button>
//         </form>

//         <div className="login-footer">
//           © {new Date().getFullYear()} Quantumnique Solutions Pvt Ltd
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Login;





import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { loginAdmin, loginManager } from "../auth";

const Login = () => {
  const [form, setForm] = useState({ username: "", password: "" });
  const [role, setRole] = useState("admin"); // admin | manager
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const from = location.state?.from?.pathname || "/dashboard";

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    let result;
    if (role === "admin") {
      result =await loginAdmin(form.username.trim(), form.password);
    } else {
      result = await loginManager(form.username.trim(), form.password);
    }


    if (!result.ok) {
      setLoading(false);
      setError(result.message || "Invalid credentials.");
      return;
    }

    // Managers always land on daily sheet; admins go to previous or dashboard
    const target = role === "manager" ? "/daily-sheet-admin" : from;
    navigate(target, { replace: true });
    setLoading(false);
  };

  return (
    <div className="login-fullpage">
      <div className="login-card">
        <div className="login-card-header">
          <div className="login-logo-big">
            <img src="/logo.png" alt="Quantumnique logo" className="login-logo-img" />
          </div>
          <div>
            <h1 className="login-title">
              {role === "manager" ? "Manager Sign In" : "Admin Sign In"}
            </h1>
            <p className="login-subtitle">
              {role === "manager"
                ? "Use your employee portal credentials (manager only)."
                : "Sign in with your admin credentials to manage payroll."}
            </p>
          </div>
        </div>

        <div className="role-toggle">
          <button
            type="button"
            className={`role-chip ${role === "admin" ? "active" : ""}`}
            onClick={() => setRole("admin")}
          >
            Admin
          </button>
          <button
            type="button"
            className={`role-chip ${role === "manager" ? "active" : ""}`}
            onClick={() => setRole("manager")}
          >
            Manager
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="fieldLogin">
            <label className="field-label-login">Username</label>
            <input
              className="field-input-login"
              name="username"
              value={form.username}
              onChange={handleChange}
              autoComplete="off"
            />
          </div>

          <div className="fieldLogin" style={{ marginTop: 12 }}>
            <label className="field-label-login">Password</label>
            <input
              className="field-input-login"
              type="password"
              name="password"
              value={form.password}
              onChange={handleChange}
              placeholder="••••••••"
            />
          </div>

          {error && <div className="login-error">{error}</div>}

          <button
            type="submit"
            className="btn-primary-large login-submit-btn"
            disabled={loading}
          >
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>

        <div className="login-footer">
          © {new Date().getFullYear()} Quantumnique Solutions Pvt Ltd
        </div>
      </div>
    </div>
  );
};

export default Login;
